export const N_GUESSES = 8
